export var DisplayMode;
(function (DisplayMode) {
    DisplayMode["Checkbox"] = "checkbox";
    DisplayMode["Toggle"] = "toggle";
    DisplayMode["List"] = "list";
    DisplayMode["Accordion"] = "accordion";
})(DisplayMode || (DisplayMode = {}));
